import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRouterModule } from '@app/router.module';


// import { CoreFormsModule } from '@core/components/forms/forms.module';

import { SettingsFormsFormModule } from './form/forms-form.module';

import { SettingsFormsMainComponent } from './main/main.component';
import { SettingsFormsMainEditComponent } from './main-edit/main-edit.component';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        SettingsFormsFormModule,
        // CoreFormsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsFormsMainComponent,
        SettingsFormsMainEditComponent
    ],
    exports: [
        SettingsFormsMainComponent,
        SettingsFormsMainEditComponent
    ],

})
export class SettingsFormsModule { }
